import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Clientes } from "../Clientes/Clientes";
import { Personal } from "../Personal/Personal";
import { Tiendas } from "../Tiendas/Tiendas";

const columns = () =>
(
    {
        vc_tiendas: new EntityColumn<string[]>({ name: 'vc_tiendas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tiendas', isArray: true }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        vc_clientes: new EntityColumn<string[]>({ name: 'vc_clientes', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes', isArray: true }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
    }
)

export class DashboardFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('DashboardFilters');
    }
}